import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { BaseSearchBarModule } from '@shared/base-search-bar/base-search-bar.module';
import {
  PackagesSearchBarMobileContainer
} from '@packages/packages-search-bar/containers/packages-search-bar-mobile/packages-search-bar-mobile.container';
import {
  PackagesSearchBarDesktopContainer
} from '@packages/packages-search-bar/containers/packages-search-bar-desktop/packages-search-bar-desktop.container';
import { PackagesSearchBarContainer } from '@packages/packages-search-bar/packages-search-bar.container';
import { SwipeUpModule } from '@ux/components/swipe-up/swipe-up.module';
import { SearchBarModule } from '@search-bar/search-bar.module';
import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { StorageServices } from '@shared/base-search-bar/services/storage.services';
import { ButtonDsComponent } from '@design-system/components/molecules/button/button.component';
import { FixedSurfaceModule } from '@ux/components/fixed-surface/fixed-surface.module';
import { InputTextDsComponent } from '@design-system/components/molecules/input-text/input-text.component';
import {
  PackagesDestinationMobileComponent
} from '@packages/packages-search-bar/components/packages-destination-mobile/packages-destination-mobile.component';
import { LoaderRingDsComponent } from '@design-system/components/atoms/loader-ring/loader-ring.component';
import {
  PackagesDestinationDesktopComponent
} from '@packages/packages-search-bar/components/packages-destination-desktop/packages-destination-desktop.component';
import {
  PackagesDestinationAutocompleteComponent
} from '@packages/packages-search-bar/components/packages-destination-autocomplete/packages-destination-autocomplete.component';
import { DropDownViewModule } from '@ux/components/drop-down-view/drop-down-view.module';
import { ButtonIconDsComponent } from '@design-system/components/molecules/button-icon/button-icon.component';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
@NgModule({
  declarations: [
    PackagesSearchBarMobileContainer,
    PackagesSearchBarDesktopContainer,
    PackagesSearchBarContainer,
    PackagesDestinationMobileComponent,
    PackagesDestinationDesktopComponent,
    PackagesDestinationAutocompleteComponent,
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    BaseSearchBarModule,
    GlobalPipesModule,
    SwipeUpModule,
    SearchBarModule,
    ButtonDsComponent,
    FixedSurfaceModule,
    InputTextDsComponent,
    LoaderRingDsComponent,
    DropDownViewModule,
    ButtonIconDsComponent,
    IconDsComponent,
    TypographyDsComponent,
  ],
  exports: [
    PackagesSearchBarMobileContainer,
    PackagesSearchBarDesktopContainer,
    PackagesSearchBarContainer,
  ],
  providers: [
    StorageServices
  ]
})
export class PackagesSearchBarModule { }
